import isSafeInteger from 'lodash/isSafeInteger';

export const isEmptyValue = value => value == null || value === '';

export const getChange = (product, actualInventoryValue) => {
  const actualInventory = Number(actualInventoryValue);

  let change = '';

  if (!isEmptyValue(actualInventoryValue) && isSafeInteger(actualInventory)) {
    const oldInventory = product.inventory;
    change = actualInventory - oldInventory;
  }

  return change;
};

export const getShrinkage = (product, actualInventoryValue) => {
  const actualInventory = Number(actualInventoryValue);

  let formattedShrinkage = '';

  if (!isEmptyValue(actualInventoryValue) && isSafeInteger(actualInventory)) {
    const oldInventory = product.inventory;

    const shrinkage = ((actualInventory - oldInventory) / oldInventory) * -100;
    formattedShrinkage = `${shrinkage.toFixed(2)} %`;
  }

  return formattedShrinkage;
};
